export const items = {
  items: [
    {
      id: "10968",
      shops: [
        [
          {
            id: 0,
            imageL:
              "https://i.ebayimg.com/00/s/MTA5M1gxMTk2/z/TH8AAOSw5FxfI~Mk/$_57.PNG?set_id=8800005007",
            name:
              "AUTHENTIC Pandora PAVE Heart Bracelet Sterling Silver Snake Chain #590727CZ NIB",
            price: 49.99,
            addedToCart: false,
          },
          {
            id: 1,
            imageL:
              "https://i.ebayimg.com/00/s/MTYwMFgxNTY4/z/q6kAAOSwZbRdWhlu/$_12.JPG?set_id=880000500F",
            name:
              "Authentic Pandora Bracelet Silver Bangle with Love Heart European Charms",
            price: 75,
            addedToCart: false,
          },
          {
            id: 2,
            imageL:
              "https://i.ebayimg.com/00/s/ODAwWDgwMA==/z/sJQAAOSwuA9cR-M2/$_57.JPG?set_id=880000500F",
            name:
              '"16"-36" Stainless Steel Silver Chain Cuban Curb Women Mens Necklace 3/5/7/9/11mm"',
            price: 5.19,
            addedToCart: false,
          },
          {
            id: 3,
            imageL:
              "https://i.ebayimg.com/00/s/ODAwWDgwMA==/z/6uYAAOSwjqxefVG8/$_12.JPG",
            name:
              "32× 20G Surgical Steel CZ Nose Pin Bone Stud Nose Hoop Ring Set Piercing Jewelry",
            price: 5.99,
            addedToCart: false,
          },
          {
            id: 4,
            imageL:
              "https://i.ebayimg.com/00/s/MTAwMFgxMDAw/z/xvsAAOSw42JWDqg9/$_57.JPG?set_id=880000500F",
            name:
              "925 Sterling Silver BOX Chain Necklace All Sizes Stamped .925 Italy ",
            price: 3.99,
            addedToCart: false,
          },
          {
            id: 5,
            imageL:
              "https://i.ebayimg.com/00/s/ODAwWDgwMA==/z/sJQAAOSwuA9cR-M2/$_57.JPG?set_id=880000500F",
            name:
              '"16"-36" Stainless Steel Silver Chain Cuban Curb Women Mens Necklace 3/5/7/9/11mm"',
            price: 5.19,
            addedToCart: false,
          },
        ],
        [
          {
            id: 0,
            imageL:
              "https://i.ebayimg.com/00/s/ODAwWDgwMA==/z/sJQAAOSwuA9cR-M2/$_57.JPG?set_id=880000500F",
            name:
              '"16"-36" Stainless Steel Silver Chain Cuban Curb Women Mens Necklace 3/5/7/9/11mm"',
            price: 5.19,
            addedToCart: false,
          },
          {
            id: 1,
            imageL:
              "https://i.ebayimg.com/00/s/MTAwMFgxMDAw/z/xvsAAOSw42JWDqg9/$_57.JPG?set_id=880000500F",
            name:
              "925 Sterling Silver BOX Chain Necklace All Sizes Stamped .925 Italy ",
            price: 3.99,
            addedToCart: false,
          },
          {
            id: 2,
            imageL:
              "https://i.ebayimg.com/00/s/ODAwWDgwMA==/z/6uYAAOSwjqxefVG8/$_12.JPG",
            name:
              "32× 20G Surgical Steel CZ Nose Pin Bone Stud Nose Hoop Ring Set Piercing Jewelry",
            price: 5.99,
            addedToCart: false,
          },
          {
            id: 3,
            imageL:
              "https://i.ebayimg.com/00/s/MTA5M1gxMTk2/z/TH8AAOSw5FxfI~Mk/$_57.PNG?set_id=8800005007",
            name:
              "AUTHENTIC Pandora PAVE Heart Bracelet Sterling Silver Snake Chain #590727CZ NIB",
            price: 49.99,
            addedToCart: false,
          },
          {
            id: 4,
            imageL:
              "https://i.ebayimg.com/00/s/MTYwMFgxNTY4/z/q6kAAOSwZbRdWhlu/$_12.JPG?set_id=880000500F",
            name:
              "Authentic Pandora Bracelet Silver Bangle with Love Heart European Charms",
            price: 75,
            addedToCart: false,
          },
          {
            id: 5,
            imageL:
              "https://i.ebayimg.com/00/s/ODAwWDgwMA==/z/6uYAAOSwjqxefVG8/$_12.JPG",
            name:
              "32× 20G Surgical Steel CZ Nose Pin Bone Stud Nose Hoop Ring Set Piercing Jewelry",
            price: 5.99,
            addedToCart: false,
          },
        ],
        [
          {
            id: 0,
            imageL:
              "https://i.ebayimg.com/00/s/ODAwWDgwMA==/z/sJQAAOSwuA9cR-M2/$_57.JPG?set_id=880000500F",
            name:
              '"16"-36" Stainless Steel Silver Chain Cuban Curb Women Mens Necklace 3/5/7/9/11mm"',
            price: 5.19,
            addedToCart: false,
          },
          {
            id: 1,
            imageL:
              "https://i.ebayimg.com/00/s/ODAwWDgwMA==/z/6uYAAOSwjqxefVG8/$_12.JPG",
            name:
              "32× 20G Surgical Steel CZ Nose Pin Bone Stud Nose Hoop Ring Set Piercing Jewelry",
            price: 5.99,
            addedToCart: false,
          },
          {
            id: 2,
            imageL:
              "https://i.ebayimg.com/00/s/MTYwMFgxNTY4/z/q6kAAOSwZbRdWhlu/$_12.JPG?set_id=880000500F",
            name:
              "Authentic Pandora Bracelet Silver Bangle with Love Heart European Charms",
            price: 75,
            addedToCart: false,
          },
          {
            id: 3,
            imageL:
              "https://i.ebayimg.com/00/s/MTA5M1gxMTk2/z/TH8AAOSw5FxfI~Mk/$_57.PNG?set_id=8800005007",
            name:
              "AUTHENTIC Pandora PAVE Heart Bracelet Sterling Silver Snake Chain #590727CZ NIB",
            price: 49.99,
            addedToCart: false,
          },
          {
            id: 4,
            imageL:
              "https://i.ebayimg.com/00/s/MTAwMFgxMDAw/z/xvsAAOSw42JWDqg9/$_57.JPG?set_id=880000500F",
            name:
              "925 Sterling Silver BOX Chain Necklace All Sizes Stamped .925 Italy ",
            price: 3.99,
            addedToCart: false,
          },
          {
            id: 5,
            imageL:
              "https://i.ebayimg.com/00/s/MTAwMFgxMDAw/z/xvsAAOSw42JWDqg9/$_57.JPG?set_id=880000500F",
            name:
              "925 Sterling Silver BOX Chain Necklace All Sizes Stamped .925 Italy ",
            price: 3.99,
            addedToCart: false,
          },
        ],
      ],
    },
    /*  */
    {
      id: "175759",
      shops: [
        [
          {
            id: 0,
            name:
              "New Levis Premium Type III Sherpa Jean Denim Jacket Sizes S-XXXL- FAST FREE SHIP",
            imageL:
              "https://i.ebayimg.com/00/s/MTA2MVg4Mjg=/z/aTAAAOSwY1Ff1M5d/$_57.JPG?set_id=8800005007",
            price: 64.95,
            addedToCart: false,
          },
          {
            id: 1,
            name: "Vintage Alpina M1 Sunglasses",
            imageL:
              "https://i.ebayimg.com/00/s/MTYwMFgxMjAw/z/eN0AAOSwIjdf9wY4/$_12.JPG?set_id=880000500F",
            price: 300,
            addedToCart: false,
          },
          {
            id: 2,
            name: "Vintage Early 1900’s Ladies Straw Hat",
            imageL:
              "https://i.ebayimg.com/00/s/MTYwMFgxNTU2/z/xYMAAOSw~Vhf8g2Q/$_12.JPG?set_id=880000500F",
            price: 25,
            addedToCart: false,
          },
          {
            id: 3,
            name:
              "Men Winter Aviator Bomber Hat Cap Mask Trapper Ear Flap Ski Face Cover Snow US",
            imageL:
              "https://i.ebayimg.com/00/s/MTUwMFgxNTAw/z/a1YAAOSwVYZf8oiu/$_57.JPG?set_id=8800005007",
            price: 11.95,
            addedToCart: false,
          },
          {
            id: 4,
            name:
              "Ladies Cashmere Black Leather Pin Logo Gloves Womans Sz Large",
            imageL:
              "https://i.ebayimg.com/00/s/NTgwWDU4MA==/z/UfkAAOSwY4Vf9xNo/$_57.JPG?set_id=8800005007",
            price: 45,
            addedToCart: false,
          },

          {
            id: 5,
            name:
              "2021 New Full Win 10 Pro Professional Genuine License KEY - Instant Delivery",
            imageL:
              "https://i.ebayimg.com/00/s/MTAwMFgxMDAw/z/0dIAAOSwfChf9d5e/$_57.JPG?set_id=8800005007",
            price: 3.39,
            addedToCart: false,
          },
        ],
        [
          {
            id: 0,
            name:
              "Vintage Coach Black Natural Leather Suede Gloves Womans Size Small",
            imageL:
              "https://i.ebayimg.com/00/s/NTgwWDU4MA==/z/R9EAAOSw~b5f9xIe/$_57.JPG?set_id=8800005007",
            price: 50,
            addedToCart: false,
          },
          {
            id: 1,
            name: "Vintage Early 1900’s Ladies Straw Hat",
            imageL:
              "https://i.ebayimg.com/00/s/MTYwMFgxNTU2/z/xYMAAOSw~Vhf8g2Q/$_12.JPG?set_id=880000500F",
            price: 25,
            addedToCart: false,
          },
          {
            id: 2,
            name:
              "Vintage 80s MISTER SOFTEE Ice Cream Truck Screen Stars T SHIRT DEADSTOCK NOS L",
            imageL:
              "https://i.ebayimg.com/00/s/MTYwMFgxMTI2/z/KhUAAOSwQHVfzbnq/$_57.JPG?set_id=8800005007",
            price: 40,
            addedToCart: false,
          },
          {
            id: 3,
            name: "Vintage Victorian Pink Ivory Organdy Gloves Costumes",
            imageL:
              "https://i.ebayimg.com/00/s/MTE5NVgxNjAw/z/cUYAAOSwtyVfVue8/$_57.JPG?set_id=8800005007",
            price: 13.95,
            addedToCart: false,
          },
          {
            id: 4,
            name: `Shoe Horn Extra Long Handle Stainless Steel 25" Metal Shoes Remover Extendable`,
            imageL:
              "https://i.ebayimg.com/00/s/ODY4WDg2OA==/z/M3MAAOSw37tf38um/$_57.JPG?set_id=8800005007",
            price: 6.19,
            addedToCart: false,
          },
          {
            id: 5,
            name:
              "Men Winter Aviator Bomber Hat Cap Mask Trapper Ear Flap Ski Face Cover Snow US",
            imageL:
              "https://i.ebayimg.com/00/s/MTUwMFgxNTAw/z/a1YAAOSwVYZf8oiu/$_57.JPG?set_id=8800005007",
            price: 11.95,
            addedToCart: false,
          },
        ],
        [
          {
            id: 0,
            name:
              "Vintage Early 1900’s Ladies Straw Hat. Beautiful Pattern And Brown Velvet Ribbon",
            imageL:
              "https://i.ebayimg.com/00/s/OTMwWDE2MDA=/z/SCQAAOSwlHdf8g43/$_12.JPG?set_id=880000500F",
            price: 25,
            addedToCart: false,
          },
          {
            id: 1,
            name:
              "Nylon Parachute Pants 80s Men's Vintage Shiny & Tight Various Colors",
            imageL:
              "https://i.ebayimg.com/00/s/NTA0WDM3NQ==/z/yPkAAOSwU-pXsSg-/$_57.JPG?set_id=8800005007",
            price: 19.95,
            addedToCart: false,
          },
          {
            id: 2,
            name:
              "*NEW* 50's Ray-ban Clip- On Sunglasses B&L 50 mm with Original Case",
            imageL:
              "https://i.ebayimg.com/00/s/MTIwMFgxNjAw/z/QoYAAOSwFVVf9xBe/$_12.JPG?set_id=880000500F",
            price: 49.99,
            addedToCart: false,
          },
          {
            id: 3,
            name:
              "Portable Lazy Shoe Helper Unisex Handled Shoe Horn Easy on& Off Shoe Lifting Kit",
            imageL:
              "https://i.ebayimg.com/00/s/MTYwMFgxNjAw/z/i4YAAOSwePdfmYtB/$_1.JPG?set_id=880000500F",
            price: 5.58,
            addedToCart: false,
          },
          {
            id: 4,
            name: `18.5" Extra Large Plastic Shoehorn - 18.5" Long Shoe Horn Handle New Pick Color`,
            imageL:
              "https://i.ebayimg.com/00/s/MTAwMFgxMDAw/z/okQAAOSw8xNalIFg/$_57.JPG?set_id=8800005007",
            price: 4.99,
            addedToCart: false,
          },
          {
            id: 5,
            name:
              "Rare Vintage Alain Mikli Sunglasses Gold Amber Brown Paris Hand Made France 80s",
            imageL:
              "https://i.ebayimg.com/00/s/MTEwNFgxNjAw/z/80AAAOSw9tFeTHEQ/$_12.JPG?set_id=880000500F",
            price: 90,
            addedToCart: false,
          },
        ],
      ],
    },
    {
      id: "32852",
      shops: [
        [
          {
            id: 0,
            imageL:
              "https://i.ebayimg.com/00/s/MTUwMFgxNTAw/z/WlEAAOSwx85cyYy7/$_57.JPG?set_id=8800005007",
            name: "Bose Solo 5 TV Sound System, Certified Refurbished",
            price: 169.95,
            addedToCart: false,
          },
          {
            id: 1,
            imageL:
              "https://i.ebayimg.com/00/s/MTA2N1gxNjAw/z/8CkAAOSwsvhe671p/$_1.JPG?set_id=880000500F",
            name: '"Westinghouse - 32" Class LED HD Smart Roku TV"',
            price: 119.99,
            addedToCart: false,
          },
          {
            id: 2,
            imageL:
              "https://i.ebayimg.com/00/s/MTMxMlgxMDQy/z/4O4AAOSwghZdxDmu/$_1.JPG?",
            name:
              "NVIDIA - SHIELD Android TV Pro - 16GB - 4K HDR Streaming Media Player with Go...",
            price: 199.99,
            addedToCart: false,
          },
          {
            id: 3,
            imageL:
              "https://i.ebayimg.com/00/s/MTQ1OFgxNTk5/z/95QAAOSw7Hlf7bfS/$_57.JPG?set_id=8800005007",
            name:
              " Roku Ultra 2020 Streaming Media Player HD/4K/HDR/Dolby Vision 4800RW",
            price: 67.99,
            addedToCart: false,
          },
          {
            id: 4,
            imageL:
              "https://i.ebayimg.com/00/s/NTUwWDU1MA==/z/~xkAAOSw6tNd-qP9/$_57.JPG?set_id=8800005007",
            name:
              "New PT390BTU Bluetooth Digital Home Theater MP3/USB/SD Stereo Receiver 300 Watt",
            price: 97.99,
            addedToCart: false,
          },
          {
            id: 5,
            imageL:
              "https://i.ebayimg.com/00/s/MTMzMFg3MTE=/z/pz8AAOSwlrpdb77g/$_57.JPG?set_id=8800005007",
            name:
              "Amazon Fire TV Stick 4K w/ Alexa Voice Remote! UNALTERED!! FACTORY SEALED!",
            price: 39.89,
            addedToCart: false,
          },
        ],
        [
          {
            id: 0,
            imageL:
              "https://i.ebayimg.com/00/s/NjQ3WDY4Mg==/z/ItEAAOSw~tpftHhY/$_57.JPG?set_id=8800005007",
            name:
              "Chromecast with Google TV - Streaming Entertainment in 4K HDR - Snow",
            price: 69.85,
            addedToCart: false,
          },
          {
            id: 1,
            imageL:
              "https://i.ebayimg.com/00/s/MTI4MFg5NjA=/z/pC4AAOSwN35f27rx/$_57.JPG?set_id=8800005007",
            name:
              "Amazon Fire TV Stick Lite with Alexa Voice Remote Control, Latest Version 2020",
            price: 29.99,
            addedToCart: false,
          },
          {
            id: 2,
            imageL:
              "https://i.ebayimg.com/00/s/MTAwMFgxMDAw/z/z4IAAOSwrXhfqyrx/$_57.JPG?set_id=8800005007",
            name:
              "NEW Amazon Fire TV Stick Lite with Alexa Voice Remote - Latest Version 2020",
            price: 29.49,
            addedToCart: false,
          },
          {
            id: 3,
            imageL:
              "https://i.ebayimg.com/00/s/MTIwMFgxNjAw/z/EGwAAOSwRHlefSAD/$_1.JPG?set_id=880000500F",
            name:
              '"Samsung TU8000 - 55" Crystal 4K UHD HDR Smart TV w/ 3 HDMI"',
            price: 477.9,
            addedToCart: false,
          },
          {
            id: 4,
            imageL:
              "https://i.ebayimg.com/00/s/MTYwMFgxNjAw/z/tVsAAOSwgyNeaXeY/$_57.JPG?set_id=8800005007",
            name:
              "Mediasonic DVD Player - 1080P Upscaling, All region DVD Player w/ HDMI AV output",
            price: 34.99,
            addedToCart: false,
          },
          {
            id: 5,
            imageL:
              "https://i.ebayimg.com/00/s/MTAyM1gxNjAw/z/Ab0AAOSwrGpelKP~/$_1.JPG?set_id=880000500F",
            name: '"Westinghouse - 43" Class LED Full HD Smart Roku TV"',
            price: 189.99,
            addedToCart: false,
          },
        ],
        /* teiko down here */
        [
          {
            id: 0,
            name:
              "HDMI Male To 3 RCA Video Audio AV Component Converter Adapter Cable HDTV 1080",
            imageL:
              "https://i.ebayimg.com/00/s/ODAwWDgwMA==/z/tIUAAOSw4AdfD4j-/$_57.JPG?set_id=8800005007",
            price: 7.99,
            addedToCart: false,
          },
          {
            id: 1,
            name:
              "HDMI Female To Female Extender Adapter Coupler Connector F/F HDTV 1080P 4K",
            imageL:
              "https://i.ebayimg.com/00/s/MTAwMFgxMDAw/z/ptYAAOSwj01dGWUb/$_57.JPG?set_id=8800005007",
            price: 0.99,
            addedToCart: false,
          },
          {
            id: 2,
            name: "Audio-Technica - Stereo Turntable - Black/Gunmetal",
            imageL:
              "https://i.ebayimg.com/00/s/MTI5NVgxNjAw/z/F6wAAOSwHjxdE5-m/$_1.JPG?set_id=880000500F",
            price: 99.99,
            addedToCart: false,
          },
          {
            id: 3,
            name:
              "NVIDIA - SHIELD Android TV Pro - 16GB - 4K HDR Streaming Media Player with Go...",
            imageL:
              "https://i.ebayimg.com/00/s/MTMxMlgxMDQy/z/-9YAAOSwEflf6ekl/$_57.JPG?set_id=8800005007",
            price: 189.99,
            addedToCart: false,
          },
          {
            id: 4,
            name: "Google Chromecast Audio Media Streamer - Black",
            imageL:
              "https://i.ebayimg.com/images/g/dnYAAOSwx-9Wtzhe/s-l640.jpg",
            price: 49.99,
            addedToCart: false,
          },
          {
            id: 5,
            name:
              "Roku Express | HD Streaming Media Player, incl. HDMI cable (2019/latest model)",
            imageL:
              "https://i.ebayimg.com/00/s/MTAwMFgxNTAw/z/BeIAAOSwlVJbSRcd/$_57.JPG?set_id=8800005007",
            price: 24.99,
            addedToCart: false,
          },
        ],
      ],
    },
  ],
  /* items: [], */
  pathLinks: [],
  loding: false, //change to true when componentDidMount
};
